import React from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles, TableRow, TableCell, IconButton, Collapse, Box, Typography } from "@material-ui/core";
import { StoreCampaign } from "../../api/themes";
import { formatDate } from "../../utils/date";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import SearchIcon from "@material-ui/icons/Search";
import { useSavedTheme } from "../../hooks/useSavedTheme";
import { useSavedSpecialDisplayType } from "../../hooks/useSavedSpecialDisplayType";

const useRowStyles = makeStyles({
  root: {
    // borderTopStyle: "solid",
    "& > *": {
      borderBottom: "unset",
    },
  },
});
const textOrLink = (cid: number, text: string) => {
  const trimmed = text.trimStart();
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
    const url = trimmed.split(" ")[0];
    return (
      <p>
        Linkki: <a href={url}>{url}</a>
      </p>
    );
  }
  const output: JSX.Element[] = [];
  trimmed.split("\n").forEach((s, i) => {
    const st = s.trimStart();
    output.push(
      <React.Fragment key={`${cid}-tx-${i}`}>
        {st.padStart(s.length, "\u2001")}
        <br />
      </React.Fragment>,
    );
  });
  return <Typography variant="body1">{output}</Typography>;
};

export const StoreCampaignRow = ({ campaign }: { campaign: StoreCampaign }): JSX.Element => {
  const classes = useRowStyles();
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const { setThemeId } = useSavedTheme();
  const { setSpecialDisplayTypeId } = useSavedSpecialDisplayType();

  const handleOpenThemeDisplays = (campaignId: number) => {
    setThemeId(campaignId);
    setSpecialDisplayTypeId(null);
    navigate("/specialdisplays");
  };

  return (
    <>
      <TableRow className={classes.root}>
        <TableCell size="small" padding="checkbox">
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>
          {campaign.name} ({campaign.store.name})
        </TableCell>
        <TableCell>
          {formatDate(campaign.startDate)} - {formatDate(campaign.endDate)}
        </TableCell>
        <TableCell size="small" padding="checkbox">
          <IconButton onClick={() => handleOpenThemeDisplays(campaign.id)}>
            <SearchIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={3}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box m={1}>
              {textOrLink(campaign.id, campaign.text)}
              <Box py={1}>
                <Typography variant="body2">
                  Tarkemmat tiedot <a href="https://alko.vuosikello.fi">Vuosikellossa</a>
                </Typography>
              </Box>
            </Box>
          </Collapse>
        </TableCell>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} />
      </TableRow>
    </>
  );
};
